import { WebhookDropdownItem, WebhookEvent } from "../types";

export const webhooks: Array<WebhookDropdownItem> = [
  {
    label: "Applicant Reviewed",
    value: WebhookEvent.APPLICANT_REVIEWED,
  },
  {
    label: "Applicant Processed ",
    value: WebhookEvent.APPLICANT_PROCESSED,
  },
  {
    label: "Applicant Created",
    value: WebhookEvent.APPLICANT_PROCESSED,
  },
  {
    label: "Applicant Approved",
    value: WebhookEvent.APPLICANT_APPROVED,
  },
  {
    label: "Applicant Overidden",
    value: WebhookEvent.APPLICANT_OVERIDE,
  },
  {
    label: "Applicant Rejected",
    value: WebhookEvent.APPLICANT_REJECTED,
  },
  {
    label: "Applicant Requires Review",
    value: WebhookEvent.APPLICANT_REQUIRES_REVIEW,
  },
  {
    label: "Company Created",
    value: WebhookEvent.COMPANY_CREATED,
  },
  {
    label: "Company Document Processed",
    value: WebhookEvent.COMPANY_DOCUMENT_PROCESSED,
  },
  {
    label: "Company Approved",
    value: WebhookEvent.COMPANY_APPROVED,
  },
  {
    label: "Company Rejected",
    value: WebhookEvent.COMPANY_REJECTED,
  },
];
